export const AnimationUtils = {
    animateElement: function ({
                                  element,
                                  animationClass,
                                  hidden = false,
                                  hide = false,
                                  incidentalElement,
                                  incidentalAnimationClass,
                                  onAnimationStart,
                                  onAnimationComplete,
                              }) {
        if (!element || !animationClass) return;

        if (hidden) element.classList.remove("hidden");

        const handleAnimationStart = () => {
            if (incidentalElement && incidentalAnimationClass) {
                incidentalElement.classList.add(incidentalAnimationClass);
            }
            if (onAnimationStart) onAnimationStart();
        };

        const handleAnimationEnd = () => {
            element.classList.remove(animationClass);
            if (incidentalElement && incidentalAnimationClass) {
                incidentalElement.classList.remove(incidentalAnimationClass);
            }
            if (hide) element.classList.add("hidden");
            if (onAnimationComplete) onAnimationComplete();

            element.removeEventListener("animationend", handleAnimationEnd);
            element.removeEventListener("animationstart", handleAnimationStart);
        };

        element.addEventListener("animationstart", handleAnimationStart);
        element.addEventListener("animationend", handleAnimationEnd);
        element.classList.add(animationClass);
    },

    transformElement: function ({
                                    element,
                                    transformation,
                                    hidden = false,
                                    hide = false,
                                    onTransformationComplete,
                                }) {
        if (!element || !transformation) return;

        if (hidden) element.classList.remove("hidden");

        const handleTransitionEnd = () => {
            if (hide) element.classList.add("hidden");
            if (onTransformationComplete) onTransformationComplete();
            element.removeEventListener("transitionend", handleTransitionEnd);
        };

        element.addEventListener("transitionend", handleTransitionEnd);
        transformation(element);
    },
};
